/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC, useState, useLayoutEffect } from "react";
import { ConfirmDialog } from "./ConfirmDialog";
import { Box, Stack, Typography } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import { useTranslation } from "react-i18next";
import { ResponseError } from "client";
import { HttpError } from "exception/HttpError";

export interface SystemErrorDialogProps {
  open: boolean;
  error?: unknown;
  onClose: () => void;
}
export const SystemErrorDialog: FC<SystemErrorDialogProps> = ({
  open,
  error,
  onClose,
}) => {
  const { t } = useTranslation();
  const [errorCodes, setErrorCodes] = useState<string[]>();

  useLayoutEffect(() => {
    if (error instanceof ResponseError) {
      error.response
        .json()
        .then((json) => {
          setErrorCodes(json.errors);
        })
        .catch((e) => {
          // Don't care
        });
    } else if (error instanceof HttpError) {
      setErrorCodes(error.errorCodes);
    }
  }, [error]);
  let status;
  if (error instanceof ResponseError) {
    status = error.response.status;
  }
  if (error instanceof HttpError) {
    status = error.statusCode;
  }
  return (
    <ConfirmDialog
      open={open}
      title={
        <Stack direction="row" alignItems="center" gap={2}>
          <WarningIcon color="error" />
          <Typography variant="inherit">{t("AWVUI-MSG136")}</Typography>
        </Stack>
      }
      message={
        <Stack
          width={"100%"}
          direction="column"
          textAlign="left"
          alignItems="flex-start"
          justifyContent="flex-start"
        >
          <Typography variant="inherit">{t("AWVUI-MSG98")}</Typography>
          <Typography variant="inherit">{t("AWVUI-MSG99")}</Typography>
          <Box sx={{ m: "1em" }}>
            {status && (
              <Typography variant="inherit">
                {`${t("AWVUI-MSG100")} ${status}`}
              </Typography>
            )}
            {errorCodes && (
              <Typography variant="inherit">
                {`${t("AWVUI-MSG101")} ${errorCodes}`}
              </Typography>
            )}
          </Box>
        </Stack>
      }
      positiveButtonText={t("AWVUI-MSG22")}
      onPositiveButtonClick={onClose}
    />
  );
};
